<template>
  <div
    ref="root"
    class="navbar-dropdown"
    :class="{ active }">
    <button
      type="button"
      class="navbar-dropdown__trigger"
      :class="{ current }"
      @click="toggle">
      <slot />
      <i class="fa-solid fa-chevron-down navbar-dropdown__icon" />
    </button>

    <div v-if="active" class="navbar-dropdown__menu">
      <AppLink
        v-for="item in items"
        :key="item.href"
        :href="item.href"
        class="navbar-dropdown__item"
        :class="{ 'navbar-dropdown__item--current': item.current }"
        @click="active = false">
        {{ item.label }}
      </AppLink>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'

defineProps({
  items: { type: Array, required: true },
  current: { type: Boolean, default: false }
})

const root = ref(null)
const active = ref(false)

function toggle() {
  active.value = !active.value
}

function handleClickOutside(e) {
  if (!root.value?.contains(e.target)) {
    active.value = false
  }
}

onMounted(() => document.addEventListener('click', handleClickOutside))
onUnmounted(() => document.removeEventListener('click', handleClickOutside))
</script>
